import React, { useContext, useState, useEffect } from "react";
import LanguageContext from "../contexts/Language";

export default function LanguageWidget({ config }) {
  const { lang, changeLanguage, getTag } = useContext(LanguageContext);

  
  function logoutHandle(ev) {
    var params = {};
    params['client_id'] = config.clientID;
    params['return_to'] = config.static_url + "/logout/"; //"https://d1sspnstatic.z11.web.core.windows.net/logout/";
    var url = createLogoutRequest(params);
    console.log('Logout -> ' + url);
    window.location.href = url;
    return false;
  }

  /**
   * ログアウトリクエスト生成
   * @param {object} in_params 設定パラメーター
   * @returns {object} ログアウトリクエストURL
   */
  function createLogoutRequest(in_params) {
    // optionに指定できるパラメーター
    //   client_id: クライアントID
    //   return_to: ログアウト後URL
    let requestUrl = `https://${config.auth0Domain}/v2/logout`;
    let paramsRaw = {};
    if (in_params.client_id)  paramsRaw.client_id = in_params.client_id;
    if (in_params.return_to)  paramsRaw.returnTo = in_params.return_to;
    if (Object.keys(paramsRaw).length > 0) {
      let params = new URLSearchParams(paramsRaw);
      requestUrl += (`?${params}`);
    }

    return requestUrl;
  }

  return (
    <div id="LoginSubMenuList" className="menulist">
      <p>
        <label><span>{getTag("common.language_title")}</span></label>
        <select id="LanguageSelector" defaultValue={lang} onChange={(ev) => changeLanguage(ev.target.value) }>
        {
          config.languages.map( l => {
            return <option key={l} value={l}>{getTag("common.language." + l)}</option>
          })
        }
        </select>
      </p>
      <p className="linklist">
        <button className="link" onClick={logoutHandle}><span>{getTag("common.logout") || "Logout"}</span></button>
      </p>
    </div>
  );
}

